import { isArray as ngIsArray, isObject, isString } from 'angular';
export var StaticLocationParamaters;
(function (StaticLocationParamaters) {
    StaticLocationParamaters["cart"] = "cart";
    StaticLocationParamaters["filters"] = "filters";
    StaticLocationParamaters["orderBy"] = "orderBy";
    StaticLocationParamaters["products"] = "products";
    StaticLocationParamaters["thirdPartyProducts"] = "thirdPartyProducts";
})(StaticLocationParamaters || (StaticLocationParamaters = {}));
var LocationService = (function () {
    function LocationService($location, localeService) {
        this.$location = $location;
        this.localeService = localeService;
        this.parameterSeparator = ',';
    }
    LocationService.prototype.add = function (parameter, parameterValue, replace) {
        if (replace === void 0) { replace = false; }
        var parameterValues = this.get(parameter, true);
        var parameterValueIndex = parameterValues.indexOf(parameterValue);
        if (parameterValueIndex > 0) {
            return;
        }
        parameterValues.push(parameterValue);
        this.$location.search(parameter, parameterValues.join(this.parameterSeparator));
        if (replace) {
            this.$location.replace();
        }
    };
    LocationService.prototype.build = function (basePath, parameters, includeStatic) {
        var _this = this;
        if (parameters === void 0) { parameters = {}; }
        if (includeStatic === void 0) { includeStatic = false; }
        var searchObject = this.lowerCase(this.$location.search());
        var staticKeys = Object.keys(StaticLocationParamaters)
            .map(function (k) { return k.toLowerCase(); });
        var parametersKeys = Object.keys(parameters)
            .map(function (k) { return k.toLowerCase(); });
        Object.keys(searchObject).forEach(function (searchObjectKey) {
            if (parametersKeys.indexOf(searchObjectKey) > -1 ||
                (!includeStatic && staticKeys.indexOf(searchObjectKey) > -1)) {
                return;
            }
            parameters[searchObjectKey] = searchObject[searchObjectKey];
        });
        var query = Object.keys(parameters)
            .map(function (parametersObjectKey) {
            var value;
            if (ngIsArray(parameters[parametersObjectKey])) {
                value = parameters[parametersObjectKey].join(_this.parameterSeparator);
            }
            else {
                value = String(parameters[parametersObjectKey] || '');
            }
            return value === '' ? '' : parametersObjectKey + "=" + value;
        })
            .filter(function (p) { return p !== ''; });
        var url = basePath + "?" + query.join('&');
        if (!url.startsWith(this.localeService.localePrefix())) {
            url = this.localeService.localePrefix() + "/" + url;
        }
        return url;
    };
    LocationService.prototype.delete = function (parameter, parameterValue, replace) {
        if (replace === void 0) { replace = false; }
        if (isString(parameterValue)) {
            var parameterValues = this.get(parameter, true);
            var parameterValueIndex = parameterValues.indexOf(parameterValue);
            if (parameterValueIndex === -1) {
                return;
            }
            parameterValues.splice(parameterValueIndex, 1);
            this.$location.search(parameter, parameterValues.join(this.parameterSeparator));
        }
        else {
            this.$location.search(parameter, null);
        }
        if (replace) {
            this.$location.replace();
        }
    };
    LocationService.prototype.get = function (parameter, isArray, separator) {
        if (isArray === void 0) { isArray = false; }
        if (separator === void 0) { separator = this.parameterSeparator; }
        var searchObject = this.lowerCase(this.$location.search());
        var parameterValue = searchObject[(parameter || '').toLowerCase()] || '';
        return isArray === true ? parameterValue.split(separator).filter(function (s) { return s !== ''; }) : parameterValue;
    };
    LocationService.prototype.has = function (parameter) {
        var parameterValue = this.get(parameter);
        return isString(parameterValue) && parameterValue !== '';
    };
    LocationService.prototype.set = function (parameter, values, replace) {
        if (replace === void 0) { replace = false; }
        var parameterValue;
        if (isString(values) && values !== '') {
            parameterValue = values;
        }
        else if (ngIsArray(values)) {
            parameterValue = values.join(this.parameterSeparator);
        }
        if (parameterValue === undefined) {
            this.$location.search(parameter, null);
        }
        else {
            this.$location.search(parameter, parameterValue);
        }
        if (replace) {
            this.$location.replace();
        }
    };
    LocationService.prototype.lowerCase = function (obj) {
        if (!isObject(obj)) {
            return obj;
        }
        var clone = {};
        Object.keys(obj).forEach(function (objKey) {
            clone[objKey.toLowerCase()] = obj[objKey];
        });
        return clone;
    };
    LocationService.$inject = ['$location', 'localeService'];
    return LocationService;
}());
export { LocationService };
